const SignalsSection = () => (
  <section className="section dark">
    <h2 className="section-title">Signals Available</h2>

    <ul className="signal-list">
      <li>EMA/ EMA Stack Level Cross</li>
      <li>Trend + Momentum Confluence</li>
      <li>Support / Resistance Breakouts</li>
      <li>Volume + VWAP Confirmation</li>
      <li>RSI and Stoch RSI exterimity Reversal Signals</li>
      <li>ICT structure Break out/ Break down</li>
      <li>ICT Breaker Retest</li>
      <li>ICT Supply / Demand Level retest</li>
    </ul>
  </section>
);

export default SignalsSection;
